import React from 'react';
import { Row, Col } from 'reactstrap';

import { FormattedTime, FormattedDate } from 'react-intl';
import { FormattedNumber, formattedNumber } from '../../FormattedNumber/FormattedNumber';
import {
  renderTradeSide,
  renderTradeQuantity,
  renderTradeSymbol,
  renderTradePrice,
} from '../../Order/Item';
import { CustomFormInput } from '../../..';
import { showDateTime, localDateTime } from "../../../utils/Helper";

const Trade = ({ trade, opsViewAccountName }) => (
  <div>
    {renderTradeSide(trade)} {renderTradeQuantity(trade)}{" "}
    {renderTradeSymbol(trade)}
    {" @ "}
    {renderTradePrice(trade)}
    <Row className="my-3">
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Status">{trade.TradeStatus}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Total">
          <FormattedNumber
            value={trade.TradeCashValue}
            dataTypeDecimalName="currency"
          />{" "}
          {trade.TradeSettleCurrencyISO}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Trading Route">
          {trade.TradeTradingRouteName}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Counter Party">
          {trade.TradeCounterPartyName}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Trade Date">
          <FormattedDate
            value={localDateTime(trade.TradeTradeDateTime).toDatetimeLocal()}
          />{" "}
          {showDateTime(trade.TradeTradeDateTime)}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Value Date">
          <FormattedDate value={`${trade.TradeValueDate}T00:00`} />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="From account">
          {opsViewAccountName == undefined ?
          (
            trade.TradeBasicAccountName
          )
          :
          (
            opsViewAccountName ?
            (
              trade.TradeBasicAccountName
            )
            :
            (
              trade.TradeBasicAccountNumber
            )
          )
          }
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="To account">
        {opsViewAccountName == undefined ?
        (
          trade.TradeOffsetBasicAccountName
        )
        :
        (
          opsViewAccountName ?
          (
            trade.TradeOffsetBasicAccountName
          )
          :
          (
            trade.TradeOffsetBasicAccountNumber
          )
        )
        }
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Trade Currency">
          {trade.TradeTradeCurrencyISO}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Settle Currency">
          {trade.TradeSettleCurrencyISO}
        </CustomFormInput>
      </Col>
      {trade.TradeTradeCurrencyId != trade.TradeSettleCurrencyId && (
        <React.Fragment>
          {trade.TradeFXRoute != "" && (
            <Col xs={6} md={4} lg={3}>
              <CustomFormInput label="FX Route">
                {formattedNumber(trade.TradeFXRoute, "currency")}
              </CustomFormInput>
            </Col>
          )}
          {trade.TradeFXRelatedOrderId > 0 && (
            <Col xs={6} md={4} lg={3}>
              <CustomFormInput label="FX Related Order">
                {trade.TradeFXRelatedOrderId}
              </CustomFormInput>
            </Col>
          )}
          <Col xs={6} md={4} lg={3}>
            <CustomFormInput label="FX">{formattedNumber(trade.TradeFX, "currency")}</CustomFormInput>
          </Col>
        </React.Fragment>
      )}
    </Row>
  </div>
);

export default Trade;
